import React from 'react';
import Header from '../Components/GlobalComponent/Header';
import Footer from '../Components/GlobalComponent/Footer';
import ApplyNow from '../Components/ApplyNowComponent/ApplyNow';
import Banner from '../Components/ApplyNowComponent/Banner';

const ApplyNowPage = () => {
    return (
        <div>
            <Header/>
            <Banner/>
            <ApplyNow/>
            <Footer/>
        </div>
    );
};

export default ApplyNowPage;
